export const environment = {
	production: false,
	apiUrl: 'https://uat-hsbc-api.podiumrewards.com/v1'
}
